export class Remittance {
    uuid?: string;
    company_id?: number;
    date?: string;
    invoices?: number[];
    totalAmount?: number;
    xml?: string;
    invoices_count?: number;
    deleted?: boolean;
    state?: string;
  
    constructor(
      uuid?: string,
      company_id?: number,
      date?: string,
      invoices?: number[],
      totalAmount?: number,
      xml?: string,
      deleted: boolean = false,
      state: string = 'pending'
    ) {
      this.uuid = uuid;
      this.company_id = company_id;
      this.date = date;
      this.invoices = invoices;
      this.totalAmount = totalAmount;
      this.xml = xml;
      this.invoices_count = invoices.length;
      this.deleted = deleted;
      this.state = state;
    }
  }


  export interface RemittanceRepository {
    get_remitances(company_id:number): Promise<{results: Remittance[], count: number}>;
    unremit_remittance(rem_uuid: string): Promise<any>;
    mark_as_paid_remittance(rem_uuid: string): Promise<any>;
    delete(remittance_ids: string[]): Promise<any>;

  }